// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eSelectAllCheckbox {
  cursor: pointer;
}

.selectAllCheckbox {
  position: relative;
}

.selectAllCheckbox > input[type='checkbox'] {
  position: relative;
  width: 18px;
  height: 18px;
  margin: 0 !important;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 5px;
  appearance: none;
  background: var(--surface-card, #fff);
  cursor: pointer;
  vertical-align: middle;
}

.selectAllCheckbox > input[type='checkbox']:hover {
  border-color: var(--blue-500, #227ebd);
}

.selectAllCheckbox > input[type='checkbox']:focus-visible {
  outline: 3px solid rgba(34, 126, 189, 0.18);
  outline-offset: 2px;
}

.selectAllCheckbox > input[type='checkbox']:checked {
  border-color: var(--blue-500, #227ebd);
  background: var(--blue-500, #227ebd);
}

.selectAllCheckbox > input[type='checkbox']:checked::after {
  position: absolute;
  top: 50%;
  left: 50%;
  color: #fff;
  content: '✓';
  font-size: 12px;
  font-weight: 800;
  line-height: 1;
  transform: translate(-50%, -52%);
}

.selectAllCheckbox.is-compact .eSelectAllCheckbox {
  min-width: 180px;
}

.eSelectAllCheckbox.dropdown-menu {
  display: block;
  min-width: 208px;
  margin: 0;
  padding: 6px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 10px;
  background: var(--surface-card, #fff);
  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.18);
}

.eSelectAllCheckbox .dropdown-item {
  display: flex;
  min-height: 36px;
  align-items: center;
  padding: 8px 10px;
  border-radius: 7px;
  color: var(--text-body, #334155);
  font-size: 13px;
  font-weight: 600;
  letter-spacing: normal;
  text-transform: none !important;
}

.eSelectAllCheckbox .dropdown-item:hover {
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
}
.eSelectAllCheckbox .dropdown-item.is-clear-selection {
  border-top: 1px solid var(--border-subtle, #e2e8f0);
  color: var(--text-muted, #64748b);
}

.eSelectAllCheckbox .dropdown-item.is-clear-selection:hover {
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-strong, #0f172a);
}

.eSelectAllCheckbox .dropdown-item.is-disabled,
.eSelectAllCheckbox .dropdown-item.is-disabled:hover {
  background: transparent;
  color: var(--text-subtle, #94a3b8);
  cursor: not-allowed;
  opacity: 0.7;
}
`, "",{"version":3,"sources":["webpack://./src/components/SelectAllCheckbox/SelectAllCheckbox.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE,mDAAmD;EACnD,iCAAiC;AACnC;;AAEA;EACE,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;;EAEE,uBAAuB;EACvB,kCAAkC;EAClC,mBAAmB;EACnB,YAAY;AACd","sourcesContent":[".eSelectAllCheckbox {\n  cursor: pointer;\n}\n\n.selectAllCheckbox {\n  position: relative;\n}\n\n.selectAllCheckbox > input[type='checkbox'] {\n  position: relative;\n  width: 18px;\n  height: 18px;\n  margin: 0 !important;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 5px;\n  appearance: none;\n  background: var(--surface-card, #fff);\n  cursor: pointer;\n  vertical-align: middle;\n}\n\n.selectAllCheckbox > input[type='checkbox']:hover {\n  border-color: var(--blue-500, #227ebd);\n}\n\n.selectAllCheckbox > input[type='checkbox']:focus-visible {\n  outline: 3px solid rgba(34, 126, 189, 0.18);\n  outline-offset: 2px;\n}\n\n.selectAllCheckbox > input[type='checkbox']:checked {\n  border-color: var(--blue-500, #227ebd);\n  background: var(--blue-500, #227ebd);\n}\n\n.selectAllCheckbox > input[type='checkbox']:checked::after {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  color: #fff;\n  content: '✓';\n  font-size: 12px;\n  font-weight: 800;\n  line-height: 1;\n  transform: translate(-50%, -52%);\n}\n\n.selectAllCheckbox.is-compact .eSelectAllCheckbox {\n  min-width: 180px;\n}\n\n.eSelectAllCheckbox.dropdown-menu {\n  display: block;\n  min-width: 208px;\n  margin: 0;\n  padding: 6px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 10px;\n  background: var(--surface-card, #fff);\n  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.18);\n}\n\n.eSelectAllCheckbox .dropdown-item {\n  display: flex;\n  min-height: 36px;\n  align-items: center;\n  padding: 8px 10px;\n  border-radius: 7px;\n  color: var(--text-body, #334155);\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: normal;\n  text-transform: none !important;\n}\n\n.eSelectAllCheckbox .dropdown-item:hover {\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n}\n.eSelectAllCheckbox .dropdown-item.is-clear-selection {\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n  color: var(--text-muted, #64748b);\n}\n\n.eSelectAllCheckbox .dropdown-item.is-clear-selection:hover {\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-strong, #0f172a);\n}\n\n.eSelectAllCheckbox .dropdown-item.is-disabled,\n.eSelectAllCheckbox .dropdown-item.is-disabled:hover {\n  background: transparent;\n  color: var(--text-subtle, #94a3b8);\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
